import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import Swap from "../swap";
import clsx from "clsx";
import { TSwap } from "@/types";
import FTAnalytic from "@/analyze/FTAnalytic";
import { FTSwapAnalyzeObj } from "@/constants";
import Analyse from "@/utils/analyse";

const SwapList = () => {
  const swapList = useCommonStore(state => state.swapList);
  const chooseTarget = useCommonStore(state => state.chooseTarget);
  const clearTarget = useCommonStore(state => state.clearTarget);

  const handleChooseTarget = (swap: TSwap) => {
    chooseTarget(swap);
  }

  return (
    <div
      className={clsx(
        styles["root"],
        "hide_scrollbar"
      )}
    >
      {swapList.map(item => (
        <Swap
          key={item.id}
          {...item}
          onRemoveTarget={() => clearTarget(item)}
          onChooseTarget={() => handleChooseTarget(item)}
        ></Swap>
      ))}
    </div>
  )
}

export default SwapList;